 

export default function FaceCapture() {
  
}
